<template>
  <workbenchDetail
    @cancelCallBack="cancel"
    @approvalConfirm="approvalConfirm"
    :backlogModel="backlogModel"
    :isHide="isHide"
  >
    <div slot="content">
       <el-form ref="form" label-width="150px" :model="dataForm">
        <el-form-item label="捐赠者类型：">
          <p>{{ dataForm.Donation === 2 ? "企业" : "个人" }}</p>
        </el-form-item>
        <el-form-item label="捐赠者名称：">
          <p>{{ dataForm.Name }}</p>
        </el-form-item>
        <el-form-item label="捐赠者电话：">
          <p>{{ dataForm.Phone }}</p>
        </el-form-item>
        <el-form-item label="捐赠项目：">
          <p>{{ dataForm.ProjectName }}</p>
        </el-form-item>
        <el-form-item label="物品配送方式：">
          <p>{{ dataForm.MailingType === 0?'':(dataForm.MailingType === 1 ? "快递邮寄" : "送货上门") }}</p>
          <P
            v-show="
              dataForm.MailingType === 1 && dataForm.DataSource === '系统'
            "
          >
            <span>快递公司:{{ dataForm.ExpressCompany }}</span>
            <br />
            <span>快递单号:{{ dataForm.ExpressNo }}</span>
          </P>
        </el-form-item>

        <el-form-item label="是否开票据：">
          <p v-if="dataForm.IsInvoice === true">需要开具票据</p>
          <p v-else>不需要开具票据</p>
        </el-form-item>
        <el-form-item label="捐赠留言：">
          <p>{{ dataForm.Remark }}</p>
        </el-form-item>
        <el-form-item label-width="50px">
          <el-table :data="materialsform" >
            <el-table-column
              prop="MaterialName"
              label="物品名称"
              sortable
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="MaterialType"
              label="品牌"
              sortable
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="Number"
              label="数量"
              sortable
              :show-overflow-tooltip="true"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="Unit"
              label="规格"
              sortable
              :show-overflow-tooltip="true"
              width="90"
            ></el-table-column>
            <el-table-column
              prop="UnitPrice"
              label="单价"
              sortable
              :show-overflow-tooltip="true"
              width="120"
            ></el-table-column>
            <el-table-column label="操作" width="150" align="center">
              <template slot-scope="scope">
                <el-button v-if="scope.row.Picture" @click="read(scope.row)" type="text" size="mini"
                  >查看图片
                </el-button>
                <el-button v-if="scope.row.File" @click="download(scope.row)" type="text" size="mini"
                  >下载附件
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
        <img
          style="width: 80%; height: 70%; margin-left: 10%"
          :src="dialogImageUrl"
          alt
        />
      </el-dialog>
    </div>
  </workbenchDetail>
</template>
<script>
import workbenchDetail from "@/modules/zjrc/pages/workbench/common/workbenchDetail";
import api from "@/modules/zjrc/api";
import { mapGetters } from "vuex";
import { saveAs } from "file-saver";

export default {
  name: "audit",
  props: {
    backlogModel: {
      type: Object,
      default: null,
    },
    isHide:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      dataForm: {}, //表单对象
      materialsform:[],//明细对象
      totalamount:0,//总金额
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  components: {
    workbenchDetail
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"])
  },
  mounted() {
    let that = this;
    that.loadData();
  },
  methods: {
    //初始化数据
    loadData() {
      let that = this;
      let params = { Id: that.backlogModel.BusinessId };
      api.QueryDonationMaterialsById(params).then((res) => {
        if (res.data.Code == 0) {
          that.dataForm = res.data.Data;
          that.getDetailList();
        }
      });
    },
    //获取物资详情
    getDetailList() {
      let that = this;
      let params = { Id: that.dataForm.Id };
      api.QueryMaterialsDetailById(params).then(function (res) {
        that.materialsform = res.data.Data;
        that.materialsform.forEach(function (item) {
          that.totalamount += item.Amount;
        });
      });
    },
    //取消
    cancel() {
      this.$emit("auditCallBack", null);
    },
    //提交数据
    approvalConfirm(data) {
      let params = Object.assign({}, data);
      api
        .AuditDonationMaterials(params)
        .then((res) => {
          if (res.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            this.$emit("auditCallBack", params);
          } else {
            this.$message({
              message: res.data.Message,
              type: "error",
            });
          }
        })
        .catch((e) => {
          this.$message({
            message: e.toString(),
            type: "error",
          });
        });
    },
    //查看图片
    read(rowData) {
      let that = this;
      that.dialogImageUrl = "/api/File/Download?Id=" + rowData.Picture;
      that.dialogVisible = true;
    },
    //下载附件
    download(rowData){
      let that=this;
      let file=JSON.parse(rowData.File);
      saveAs("/api/File/Download?Id=" + file[0].url, file[0].name);
    }
  }
};
</script>

<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.hide .el-button--default {
  display: none !important;
}
</style>

<style>

</style>